/*
  YOG-957 — Hide the RestockRocket "notify when available" button for variants
  the theme considers in stock via location-based availability (YOG-920).

  RestockRocket keys off Shopify native inventory, which can diverge from the
  per-location stock (tracked in variant metafields). When the theme shows the
  variant as available ("Skladem" + Add to cart), the notify button must not
  appear. We only override that divergent case: when locationAvailable === true
  we hide the injected button; otherwise RestockRocket behaves normally.
*/
(function () {
  function initProductInfo(productInfo) {
    if (productInfo.dataset.sgaRestockBound) return;
    productInfo.dataset.sgaRestockBound = 'true';

    const variantPicker = productInfo.querySelector('variant-picker');

    function selectedVariantId() {
      const input = productInfo.querySelector('[name="id"]');
      return input ? input.value : null;
    }

    // Read fresh each time — for combined listings the variant-picker data
    // is swapped in on variant change.
    function locationAvailable(variantId) {
      if (!variantPicker || !variantId) return undefined;
      const dataEl = variantPicker.querySelector('script[data-refresh-with-variant="variant-picker-script"]');
      if (!dataEl) return undefined;
      try {
        const formatted = JSON.parse(dataEl.textContent).formatted || {};
        const variant = formatted[variantId];
        return variant ? variant.locationAvailable : undefined;
      } catch (e) {
        return undefined;
      }
    }

    function apply() {
      const available = locationAvailable(selectedVariantId());
      productInfo.querySelectorAll('.restock-rocket-button-container').forEach((el) => {
        if (available === true) {
          el.style.display = 'none';
        } else {
          el.style.removeProperty('display');
        }
      });
    }

    let scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      // setTimeout (not requestAnimationFrame) so it still fires for PDPs
      // opened in a background tab, where rAF is paused.
      setTimeout(() => {
        scheduled = false;
        apply();
      }, 0);
    }

    if (variantPicker) {
      variantPicker.addEventListener('on:variant:change', schedule);
    }

    // RestockRocket injects/updates its button asynchronously.
    new MutationObserver(schedule).observe(productInfo, { childList: true, subtree: true });

    apply();
  }

  document.querySelectorAll('.product-info').forEach(initProductInfo);
})();
